import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  Stack,
  Chip,
  Switch,
  FormControlLabel,
  Divider,
} from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon, DarkMode as DarkModeIcon, LightMode as LightModeIcon } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';
import api from '../utils/api';

function Settings() {
  const { isDarkMode, toggleTheme } = useTheme();
  const [settings, setSettings] = useState({
    telegramChatIds: [],
  });
  const [newChatId, setNewChatId] = useState('');

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings/notifications');
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleAddChatId = () => {
    if (newChatId && !settings.telegramChatIds.includes(newChatId)) {
      const updatedIds = [...settings.telegramChatIds, newChatId];
      handleSaveSettings(updatedIds);
      setNewChatId('');
    }
  };

  const handleDeleteChatId = (chatId) => {
    const updatedIds = settings.telegramChatIds.filter(id => id !== chatId);
    handleSaveSettings(updatedIds);
  };

  const handleSaveSettings = async (telegramChatIds) => {
    try {
      const response = await api.put('/settings/notifications', {
        telegramChatIds
      });
      setSettings(response.data);
    } catch (error) {
      console.error('Error saving settings:', error);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Внешний вид
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={isDarkMode}
              onChange={toggleTheme}
              icon={<LightModeIcon />}
              checkedIcon={<DarkModeIcon />}
            />
          }
          label={isDarkMode ? "Темная тема" : "Светлая тема"}
        />
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 3 }}>
          Настройки уведомлений
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Telegram Chat IDs для уведомлений
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
            <TextField
              fullWidth
              label="Новый Chat ID"
              value={newChatId}
              onChange={(e) => setNewChatId(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAddChatId();
                }
              }}
            />
            <Button
              variant="contained"
              onClick={handleAddChatId}
              disabled={!newChatId}
              startIcon={<AddIcon />}
            >
              Добавить
            </Button>
          </Stack>

          <Stack direction="row" spacing={1} flexWrap="wrap">
            {settings.telegramChatIds.map((chatId) => (
              <Chip
                key={chatId}
                label={chatId}
                onDelete={() => handleDeleteChatId(chatId)}
                sx={{ m: 0.5 }}
              />
            ))}
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}

export default Settings;